// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","379":"1bfc9850","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"81202c78063864ca87ac","245":"1ba8136cfc183699afe1","379":"fca51289974097b72f52","452":"45b49179ad6033fb2bf0","453":"e1c9fa252a785d78b5a1","577":"98a9f9c20f2b71951480"}[chunkId] + ".js";
};